
const DecayLockReducer = (state = false, action) => {
    switch (action.type) {
        case 'TOGGLE_DECAY_LOCK':
            return !state;
        default:
            return state;
    }
}

export default DecayLockReducer;